export const createStringManager = (timeRange) => {
    const storage = []; // 用于存储字符串和时间戳的数组
  
    return {
      // 添加字符串和时间戳
      addString(str) {
        const timestamp = Date.now(); // 当前时间戳
        storage.push({ value: str, timestamp }); // 添加到存储数组
        this.cleanUp(); // 移除过期的字符串
      },
      // 判断某个字符串是否存在
      hasString(str) {
        this.cleanUp(); // 确保移除过期的记录
        return storage.some(item => item.value === str);
      },
  
      // 获取当前的有效字符串列表
      getStrings() {
        this.cleanUp(); // 确保移除过期的记录
        return storage.map(item => item.value);
      },
  
      // 清理超过时间范围的字符串
      cleanUp() {
        const currentTime = Date.now();
        // 过滤出时间范围内的记录
        const validTime = currentTime - timeRange;
        while (storage.length && storage[0].timestamp < validTime) {
          storage.shift(); // 移除最早的记录
        }
      }
    };
}